import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

const validate_login_api = "https://fcsn6t.deta.dev/account/check";
const insert_article_api = "https://fcsn6t.deta.dev/article/insert";

const Createpost = () => {
  const [login, setLogin] = useState({
    login_status: false,
    token: null,
  });
  const [newArticle, setNewarticle] = useState({
    title: "",
    body: "",
  });
  const [sendArticle, setSendarticle] = useState(false);
  const [apiError, setApierror] = useState("");
  const router_hystory = useHistory();
  const router_location = useLocation();
  const checkLogin = (auth_token) => {
    fetch(validate_login_api, {
      method: "GET",
      headers: {
        "X-Token": auth_token,
      },
    })
      .then((data) => data.json())
      .then((json) => {
        if (json.error) {
          if (json.error === "Token expire") {
            console.log(json.error);
            router_hystory.push("/login");
          } else {
            setApierror(json.error + " Reload page");
            window.location.pathname = router_location.pathname;
          }
        } else {
          if (json.validate === true) {
            setLogin({
              login_status: true,
              token: auth_token,
            });
          } else {
            //pass
          }
        }
      });
  };
  const handleArticletitlechange = (e) => {
    setNewarticle({
      ...newArticle,
      title: e.target.value,
    });
  };
  const handleArticlebodychange = (e) => {
    setNewarticle({
      ...newArticle,
      body: e.target.value,
    });
  };

  const submitArticle = (e) => {
    e.preventDefault();
    let title = newArticle.title;
    let body = newArticle.body;
    let random_id =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
    if (title && body) {
      if (
        title === "" ||
        title === " " ||
        title === "  " ||
        title === "   " ||
        title === "    " ||
        title === "     "
      ) {
        //pass
        console.log("vuoto");
      } else {
        const article = {
          title: title,
          body: body,
          obj_id: random_id,
        };
        fetch(insert_article_api, {
          method: "PUT",
          body: JSON.stringify(article),
          headers: {
            "X-Token": login.token,
          },
        })
          .then((data) => data.json())
          .then((json) => {
            if (json.action) {
              setSendarticle(true);
              setNewarticle({
                title: "",
                body: "",
              });
            } else if (json.error) {
              if (json.error === "Token expire") {
                console.log(json.error);
                router_hystory.push("/login");
              } else {
                setApierror(json.error + " Try again");
              }
            }
          });
      }
    } else {
      console.log("vuoto null");
    }
  };
  const createNewarticle = () => setSendarticle(false);

  useEffect(() => {
    let jsonToken = sessionStorage.getItem("xtoken");
    if (jsonToken) {
      let authtoken = JSON.parse(jsonToken).id_token;
      checkLogin(authtoken);
    } else {
      router_hystory.push("/login");
    }
  }, []);

  const new_article_viewer_manager = () => {
    if (login.login_status) {
      if (sendArticle) {
        return (
          <span>
            <p>Article sent</p>
            <button onClick={createNewarticle}>Create new</button>
          </span>
        );
      } else {
        return (
          <form className="form" onSubmit={submitArticle}>
            <input
              type="text"
              placeholder="title"
              value={newArticle.title}
              onChange={handleArticletitlechange}
            ></input>
            <br />
            <textarea
              placeholder="content"
              value={newArticle.body}
              onChange={handleArticlebodychange}
            ></textarea>
            <br />
            <button type="submit">pubblish</button>
          </form>
        );
      }
    } else {
      return <span>Caricamento...</span>;
    }
  };
  let new_article_viewer = new_article_viewer_manager();

  return (
    <div>
      <h1>New article</h1>
      {new_article_viewer}
      {apiError}
    </div>
  );
};

export default Createpost;
